// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3492) return "static/chunks/3492-a81910b52981d01e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "ced8bfd49022c0b4" + ".js";
};